<template>
  <main class="container my-5">
    <h4>
      Detalhes do pedido #{{
        objPedido &&
        !!objPedido.pedido.codigoReferencia &&
        objPedido.pedido.codigoReferencia.toUpperCase().substring(0, 8)
      }}
    </h4>
    <DetalhesPedidos
      v-if="objPedido && !loading"
      :objPedido="objPedido"
      @cancelarPedido="cancelarPedido"
    />

    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from '../APIService'
const apiService = new APIService()
import DetalhesPedidos from '../components/pedidos/DetalhesPedidos'
import Loading from '@/components/Loading.vue'

export default {
  name: 'DetalhesPedido',
  components: {
    DetalhesPedidos,
    Loading,
  },
  data() {
    return {
      objPedido: null,
      idPedido: this.$route.params.idPedido,
      loading: true,
      formaPagamento: null,
    }
  },
  mounted() {
    this.getDetalhes(this.idPedido)
  },
  methods: {
    getDetalhes(id) {
      if (id > 0) {
        this.loading = true
        apiService
          .getPedidoID(id)
          .then((response) => {
            this.objPedido = response

            this.pedidoCarregado = true
            this.loading = false
          })
          .catch(() => {
            this.pedidoCarregado = true
            this.loading = false
          })
      } else {
        this.loading = false
      }
    },
    cancelarPedido(motivoCancelamento) {
      const estorno = {
        codigoReferencia:
          this.objPedido.pedido.pagamento == null
            ? null
            : this.objPedido.pedido.pagamento.codigoReferencia,
        descricaoMotivo: motivoCancelamento,
      }
      apiService
        .cancelarPedido(this.objPedido.pedido.id, estorno)
        .then(() => {
          this.$swal({
            title: 'Solicitação de cancelamento',
            text:
              'Sua solicitação foi realizada com sucesso, em breve você receberá mais informações por e-mail.',
          })
          this.getDetalhes(this.idPedido)
          this.removeCarrinho()
        })
        .catch(() =>
          this.$swal({ text: 'Não foi possível realizar o cancelamento' }),
        )
    },
    removeCarrinho() {
      localStorage.removeItem('carrinho')
      this.$store.state.pedido.itens = []
      this.$store.state.pedido.valorTotal = 0
      this.$store.state.pedido.valorFrete = 0
      this.$store.state.pedido.valorCompra = 0
      this.$store.state.pedido.valorDesconto = 0
      this.$store.state.pedido.id = null
    },
  },
}
</script>
<style scoped lang="scss"></style>
